import type { PerspectiveCamera, Scene, WebGLRenderer } from 'three'
import type { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import type { TransformControls } from '../control/transformControls'
import type Group from '../group'
import type { ControlsType, UniversalControls } from '../control/UniversalControls'
import type {EnvManager} from '../scene/envManager'

class GlobalObjectManage {
  public id = '0'
  public scene!: Scene
  public domElement!: HTMLElement
  public renderer!: WebGLRenderer
  public orbitControls!: ControlsType
  public triggerClick = false
  public camera!: PerspectiveCamera
  public transformControls: TransformControls[] = []
  public envManager!: EnvManager

  // hooks callback
  public frameCallbacks = new Set<(delta: number) => void>()
  public frameCallbacksAfterRender = new Set<(delta: number) => void>()
  public frameComposerFrameRender = new Set<() => void>()
  public frameSubComposerFrameRender: Set<() => void> = new Set()

  public eventCallbacks: Map<string, Set<((args?: any) => void)>> = new Map()

  // instance
  public groupCatch: Group[] = []
  public universalControls!: UniversalControls

  constructor() {

  }

  public setId(id: string) {
    this.id = id
  }

  public addScene(object3d: Scene) {
    this.scene = object3d
  }

  public setCamera(camera: PerspectiveCamera) {
    this.camera = camera
  }

  public setDomElement(domElement: HTMLElement) {
    this.domElement = domElement
  }

  public setRenderer(renderer: WebGLRenderer) {
    this.renderer = renderer
  }

  // 设置当前控制器
  public setControls(orbitControls: ControlsType) {
    this.orbitControls = orbitControls
  }

  // 设置通用控制器，包括轨道控制器和变换控制器
  public setUniversalControls(universalControls: UniversalControls) {
    this.universalControls = universalControls
  }

  public setTransformControls(transformControls: TransformControls) {
    this.transformControls.push(transformControls)
  }

  public setTriggerClickState(state: boolean) {
    this.triggerClick = state
  }

  public addFrameCallback(cb: (delta: number) => void) {
    this.frameCallbacks.add(cb)
  }

  public addSubComposerFrameRender(cb: () => void) {
    this.frameSubComposerFrameRender.add(cb)
  }

  public removeSubComposerFrameRender(cb: () => void) {
    this.frameSubComposerFrameRender.delete(cb)
  }

  public removeFrameCallback(cb: (delta: number) => void) {
    this.frameCallbacks.delete(cb)
  }

  public addFrameCallbackAfterRender(cb: (delta: number) => void) {
    this.frameCallbacksAfterRender.add(cb)
  }

  public addFrameComposerFrameRender(cb: () => void) {
    this.frameComposerFrameRender.add(cb)
  }

  public removeFrameComposerFrameRender(cb: () => void) {
    this.frameComposerFrameRender.delete(cb)
  }

  public removeFrameCallbackAfterRender(cb: (delta: number) => void) {
    this.frameCallbacksAfterRender.delete(cb)
  }

  public addCatch(group: Group) {
    this.groupCatch.push(group)
  }

  public setEnvManager(envManager: EnvManager) {
    this.envManager = envManager
  }
}

export default new GlobalObjectManage()
